import { NgModule } from '@angular/core';
import { FeatureToggleService } from './feature-toggle.service';
import { FeatureToggleInitializer } from './feature-toggle-initializer';

@NgModule({
  providers: [FeatureToggleService, FeatureToggleInitializer],
})
export class FeatureToggleModule {}
